import React from 'react';
import { Box, Text, Link } from '@chakra-ui/react';

interface SignInFooterProps {
  isMobile?: boolean;
}

export const SignInFooter: React.FC<SignInFooterProps> = ({ isMobile }) => (
  <Box textAlign="center" pb={isMobile ? 2 : 0} mt={isMobile ? 2 : 6}>
    <Text fontSize="xs" color="textMuted">
      By signing in you agree to our{' '}
      <Link href="/terms" color="accent">Terms of Service</Link>
      {' '}and{' '}
      <Link href="/privacy" color="accent">Privacy Policy</Link>.
    </Text>
  </Box>
);
